import React from 'react';
import cx from 'classnames';

import { BonusesListTabsSkeleton, BonusListCardSkeleton } from '@atlas/ui';

const BonusListSkeleton = () => (
  <>
    <div className={cx('bonus-card-chips-list', 'chips-list')}>
      <BonusesListTabsSkeleton />
    </div>
    <div className="bonus-card-list-wrapper bonus-history-list bonus-card-skeleton">
      <BonusListCardSkeleton />
      <BonusListCardSkeleton />
      <BonusListCardSkeleton />
    </div>
  </>
);

export default BonusListSkeleton;
